export default [
  { label: 'CNPJ/CPF', field: 'cadastroFederal' },
  { label: 'Nome', field: 'razaoSocial' },
]
